import { withTranslate } from "@pathwright/ui/src/components/"
import Tooltip from "@pathwright/ui/src/components/tooltip/Tooltip"
import moment from "moment"
import "./RegistrationClosed.css"

const tPrefix = "registration.closed"

const RegistrationClosed = function (props) {
  const { offering, isFull, staffContact, invitation, t, Trans } = props

  return (
    <div className="RegistrationClosed">
      {moment().isBefore(offering.enrollment_starts) ? (
        <Tooltip
          title={t(`${tPrefix}.opens_on_tooltip`, {
            opens_on: moment(offering.enrollment_starts).format("LLL")
          })}
        >
          <p>
            {t(`${tPrefix}.opens_on`, {
              opens_on: moment(offering.enrollment_starts).fromNow()
            })}
            .
          </p>
        </Tooltip>
      ) : moment().isAfter(offering.enrollment_ends) ? (
        <Tooltip
          title={t(`${tPrefix}.closed_on_tooltip`, {
            closed_on: moment(offering.enrollment_ends).format("LLL")
          })}
        >
          <p>
            {t(`${tPrefix}.closed_on`, {
              closed_on: moment(offering.enrollment_ends).fromNow()
            })}
            .
          </p>
        </Tooltip>
      ) : isFull ? (
        // prettier-ignore
        // Trans formatting integral to translation json!
        <>
          <Trans parent="p" i18nKey={`${tPrefix}.access_not_available`}>
            Access unavailable.
          </Trans>
          {!!staffContact && (
            // prettier-ignore
            // Trans formatting integral to translation json!
            <Trans i18nKey={`${tPrefix}.staff_contact`}>
              Contact {{ staffName: staffContact.full_name }} at{" "}
              <a href={`mailto:${staffContact.email}`}>{{ staffEmail: staffContact.email }}</a>{" "}
              with any questions.
            </Trans>
          )}
        </>
      ) : invitation && invitation.offering_registration ? (
        <p>{t(`${tPrefix}.invitation_already_used`)}</p>
      ) : null}
    </div>
  )
}

RegistrationClosed.displayName = "RegistrationClosed"

export default withTranslate(RegistrationClosed)
